module.exports = __webpack_public_path__ + "images/rich_heading/sports/golf_club/icon_7e199b35fc1ea262d02efa97a1ce4adb.png";